import SignoutOidc from './SignoutOidc';

export default SignoutOidc;
